import OvertimeTicketDetail from './OvertimeTicketDetail';

export default OvertimeTicketDetail;
